// ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  // Check for your authentication values (e.g., in sessionStorage)
  const username = sessionStorage.getItem("username");
  const sessionId = sessionStorage.getItem("s_id");

  // If authenticated, render the child routes (Outlet), otherwise redirect to login
  return username && sessionId ? <Outlet /> : <Navigate to="/auth/login" replace />;
};

export default ProtectedRoute;
